import React, { createContext, useContext, useState } from 'react';

type StatusContextValue = {
  statusUpdateDate: Date | null;
  setStatusUpdateDate: React.Dispatch<React.SetStateAction<Date | null>>;
};

const StatusContext = createContext<StatusContextValue | undefined>(undefined);

export function StatusUpdateDateProvider({ children }: { children: React.ReactNode }) {
  const [statusUpdateDate, setStatusUpdateDate] = useState<Date | null>(null);

  return React.createElement(
    StatusContext.Provider,
    { value: { statusUpdateDate, setStatusUpdateDate } },
    children
  );
}

export function useStatusUpdateDate() {
  const ctx = useContext(StatusContext);
  if (!ctx)
    throw new Error('usePermitStatusUpdateDate must be used within PermitStatusUpdateDateProvider');
  return ctx;
}
